/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/baa-page.pug';
import metadata from './metadata.json';
import baaPapers from './data/baaPapers.json';

export default function register() {
  page('/legal/baseline/baa', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    baaPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/baa/baa.js